import { Backdrop, Box, CircularProgress, Divider, FormLabel, Grid, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import custumTheme from "../../../../thems/userFromThems";
import { OutlineInput } from "../utilis/OutlineInput";
import { usersFilds } from "../utilis/userData";
import Button from "components/ui/Button";
import { json, useLocation, useNavigate, useParams } from "react-router-dom";
import { useSettingContext } from "context/SettingContext";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import useGetAllUsersData from "features/Setting/users/hooks/useGetAllUsers";
import useEditUser from "features/Setting/users/hooks/useEditUser";
import useCreateUser from "features/Setting/users/hooks/useCreateUser";
import { ToastContainer, toast } from "react-toastify";
import { getAllowCompanyIps, getAllRoles, getProjectRoles } from "features/Setting/Role/Apis/get-role";
import { AllowIp } from "../utilis/AllowIp";
import { AddAllowIPModel } from "../utilis/AddAllowIPModel";
import { dyanamicIpData } from "../utilis/ipData";
import { IOSSwitch } from "features/Setting/My_Binnys_Access/IOSSwitch";
import CalenderComp from "features/Setting/order/components/CalenderComp";
import { min } from "lodash";
import { AllowIpFrom } from "./AllowIpFrom";
import { formatDate } from "utils/formatDate";
import { useGlobalContext } from "context/GlobalContext";

export const CreateUserFrom = () => {
  const { cancelEditUserModal, setCancelEditUserModal, setCancelEditChanges, setUserCreatedStatus, setUserEditStatus, setIsDisable, setCreateBtn, setCreateBtnName, setOnSave, search, setSearch } =
    useSettingContext();
  const { setSearchPlaceHolder, setTotals, sortOptions, setSortOptions, sortValue, setSortValue } = useGlobalContext();

  const { id } = useParams();
  const navigation = useNavigate();
  const location = useLocation();
  const [initialUserInfo, setInitialUserInfo] = useState({});
  const [userInfo, setUserInfo] = useState({
    username: "",
    firstName: "",
    lastName: "",
    role: "",
    createProjectRole: "",
    selectProjectRole: "",
    password: "",
    confirmPassword: "",
    email: "",
    entity: "",
  });
  const [allowIp, setAllowIp] = useState([]);
  const [initialAllowIpData, setInitialAllowIpData] = useState({});
  const [compantAllowIpData, setCompanyAllowIpData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [allowFullAccess, setAllowFullAccess] = useState(false);
  const [roleData, setRoleData] = useState([]);
  const [createProjectRoleData, setCreateProjectRoleData] = useState([]);
  const [selectProjectRoleData, setSelectProjectRoleData] = useState([]);

  const selectedOption = sortOptions.find((option) => option.id == sortValue);
  const selectedSortBY = selectedOption?.sortBy || "createdAt";
  const selectedSortOrder = selectedOption?.order || "desc";

  const { data: allUsers } = useGetAllUsersData({ sortBy: selectedSortBY, sortOrder: selectedSortOrder, search: search });
  const {
    mutate: updateUser,
    isError: updateIsError,
    isSuccess: updateIsSuccess,
    error: updateError,
    isPending: updateUserLoading,
  } = useEditUser({ sortBy: selectedSortBY, sortOrder: selectedSortOrder });
  const { mutate: createUser, isError: addIsError, isSuccess: addIsSuccess, error: addError, isPending: createUserLoading } = useCreateUser({ sortBy: selectedSortBY, sortOrder: selectedSortOrder });

  const handleChnage = (e) => {
    const { name, value } = e.target;
    setUserInfo((preData) => ({
      ...preData,
      [name]: value,
    }));
  };

  const findEmptyValue = () => {
    let onlyKeyChecks = ["username", "firstName", "lastName", "password", "confirmPassword"];
    let atLeastOneCheckRole = ["role", "createProjectRole", "selectProjectRole"];
    for (let key of onlyKeyChecks) {
      if (!userInfo[key] || userInfo[key].trim() === "") {
        return true; // field empty
      }
    }
    const hasAtLeastOneRole = atLeastOneCheckRole.some((item) => userInfo[item] && userInfo[item].trim() !== "");
    if (!hasAtLeastOneRole) {
      return true;
    }

    if (userInfo.password.trim() !== userInfo.confirmPassword.trim()) {
      return true;
    }

    if ((allowIp && allowIp.length > 0 && allowFullAccess && !selectedDate) || selectedDate === "") {
      return true;
    }

    return false;
  };

  const findEditValue = (data) => {
    if (
      data["username"] === initialUserInfo["username"] &&
      data["firstName"] === initialUserInfo["firstName"] &&
      data["lastName"] === initialUserInfo["lastName"] &&
      data["password"] === initialUserInfo["password"] &&
      data["confirmPassword"] === initialUserInfo["confirmPassword"] &&
      data["role"] === initialUserInfo["role"] &&
      data["createProjectRole"] === initialUserInfo["createProjectRole"] &&
      data["selectProjectRole"] === initialUserInfo["selectProjectRole"] &&
      data["email"] === initialUserInfo["email"] &&
      data["entity"] === initialUserInfo["entity"] &&
      JSON.stringify(allowIp) === JSON.stringify(initialAllowIpData?.ips) &&
      initialAllowIpData?.selectedDate === selectedDate
    ) {
      return true;
    }

    if (userInfo.password !== userInfo.confirmPassword) {
      return true;
    }

    let onlyKeyChecks = ["username", "firstName", "lastName", "password", "confirmPassword"];
    let atLeastOneCheckRole = ["role", "createProjectRole", "selectProjectRole"];

    for (let key of onlyKeyChecks) {
      if (key !== "password" && key !== "confirmPassword" && userInfo[key].trim() === "") {
        return true;
      }
    }

    const hasAtLeastOneRole = atLeastOneCheckRole.some((item) => userInfo[item] && userInfo[item].trim() !== "");
    if (!hasAtLeastOneRole) {
      return true;
    }

    return false;
  };

  const handleSubmitUserForm = () => {
    const roleRef = roleData.find((item) => item.role === userInfo.role.trim());
    const createProjectRoleRef = createProjectRoleData.find((item) => item?.role === userInfo?.createProjectRole.trim());
    const selectProjectRoleRef = selectProjectRoleData.find((item) => item?.role === userInfo?.selectProjectRole.trim());
    const ipData = {
      ips: allowIp?.map((ip) => ({ from: ip.from_ip, to: ip?.to_ip })),
      isAllowFullAccess: selectedDate ? true : false,
      allowFullAccessDate: selectedDate || null,
    };

    const trimmedUserInfo = {
      username: userInfo.username.trim(),
      firstName: userInfo.firstName.trim(),
      lastName: userInfo.lastName.trim(),
      role: roleRef?._id,
      createProjectRole: createProjectRoleRef?._id,
      selectProjectRole: selectProjectRoleRef?._id,
      password: userInfo.password.trim(),
      confirmPassword: userInfo.confirmPassword.trim(),
      allowIp: ipData,
      email: userInfo.email.trim(),
      entity: userInfo.entity || undefined,
    };

    if (id) {
      const updatedUserInfo = {
        ...trimmedUserInfo,
        userId: id,
      };
      updateUser(updatedUserInfo);
    } else {
      createUser(trimmedUserInfo);
      setSortValue("");
      setSearch("");
    }
  };

  const handleDiscardChanges = () => {
    const state = { ...location.state, isEditUser: false, name: [`Users`] };
    navigation("/Setting/users", { state });
    setCancelEditUserModal(false);
  };

  const modalBtnInfo = useMemo(
    () => [
      {
        btnName: "Discard",
        bgColor: "#E77B7B",
        click: handleDiscardChanges,
      },
      {
        btnName: "Keep",
        bgColor: "#50C878",
        click: () => setCancelEditUserModal(false),
      },
    ],
    [handleDiscardChanges]
  );

  useEffect(() => {
    const fetchData = () => {
      if (allUsers && id) {
        let editUserData = allUsers?.data?.User.find((user) => user._id === id);
        if (editUserData) {
          setUserInfo({
            username: editUserData.username || "",
            firstName: editUserData.firstName || "",
            lastName: editUserData.lastName || "",
            role: editUserData.role?.roleName || "",
            createProjectRole: editUserData.createProjectRole?.name || "",
            selectProjectRole: editUserData.selectProjectRole?.name || "",
            email: editUserData.email || "",
            entity: editUserData.entity || "",
            // password: editUserData.plainPassword || "",
            // confirmPassword: editUserData.plainPassword || "",
            password: "",
            confirmPassword: "",
          });

          let edit_selectedDate = editUserData?.allowFullAccessDate ? formatDate(editUserData?.allowFullAccessDate) : null;
          setSelectedDate(edit_selectedDate);
          // setAllowFullAccess(editUserData?.isAllowFullAccess);

          if (compantAllowIpData && compantAllowIpData?.length) {
            let data = editUserData?.allowIpRef?.ips?.map((ip) => ({ from_ip: ip?.from, to_ip: ip?.to })) || [];
            setAllowIp([...compantAllowIpData, ...data]);
            setInitialAllowIpData({ ips: [...compantAllowIpData, ...data], allowFullAccess: editUserData?.isAllowFullAccess, selectedDate: edit_selectedDate });
          }

          // delete editUserData._id;

          setInitialUserInfo((prevState) => ({
            ...prevState,
            ...editUserData,
            role: editUserData.role?.roleName || "",
            createProjectRole: editUserData.createProjectRole?.name || "",
            selectProjectRole: editUserData.selectProjectRole?.name || "",
            entity: editUserData.entity || "",
            // password: editUserData.plainPassword || "",
            // confirmPassword: editUserData.plainPassword || "",
            password: "",
            confirmPassword: "",
          }));
        }
      }
    };
    fetchData();
  }, [id, allUsers, compantAllowIpData]);

  useEffect(() => {
    if (!id && compantAllowIpData) {
      setAllowIp(compantAllowIpData);
    }
  }, [compantAllowIpData, id]);

  useEffect(() => {
    setCancelEditUserModal(false);
  }, [id]);

  const checkEditorNot = (data) => {
    if (data) {
      const isChnages = findEditValue(data);
      setCancelEditChanges(isChnages);
      return isChnages;
    }
  };

  useEffect(() => {
    if (addIsSuccess || updateIsSuccess) {
      if (addIsSuccess) setUserCreatedStatus(true);
      if (updateIsSuccess) setUserEditStatus(true);
      setCompanyAllowIpData([]);
      const state = { ...location.state, isEditUser: false, name: [`Users`] };
      navigation("/Setting/users", { state });
    } else if (addIsError || updateIsError) {
      console.log("addIsError || updateIsError ==>", { addIsError, updateIsError });
      toast.error(`${addError?.response?.data?.message || addError?.message || updateError?.message || updateError || "Something went wrong"}`, {
        position: "top-right",
        autoClose: 3000,
      });
    }
  }, [addIsSuccess, updateIsSuccess, addIsError, updateIsError, addError, updateError]);

  const fetchRoles = async () => {
    try {
      const data = await getAllRoles();
      const newData = data?.data?.map((item) => ({
        _id: item._id,
        role: item.roleName,
      }));
      setRoleData(newData);
    } catch (error) {
      console.log("Some thing Went Wrong When Call Roles");
    }
  };

  const fetchProjectRoles = async ({ projectName, setProjectRoleDetails }) => {
    try {
      const data = await getProjectRoles({ projectName });
      const newData = data?.role?.map((item) => ({
        _id: item.id,
        role: item.name,
      }));
      setProjectRoleDetails(newData);
    } catch (error) {
      console.log(`Some thing Went Wrong When Call ${projectName} Roles`);
    }
  };

  const fetchCompnayAllowIps = async () => {
    try {
      const data = await getAllowCompanyIps();
      const newData = data?.Company[0]?.ips?.map((ip) => ({
        from_ip: ip?.from,
        to_ip: ip?.to,
        networkType: data?.Company[0]?.networkType,
      }));
      setCompanyAllowIpData(newData);
    } catch (error) {
      console.log(`Some thing Went Wrong When Call Ips.`);
    }
  };

  useEffect(() => {
    fetchRoles();
    fetchProjectRoles({ projectName: "CREATE", setProjectRoleDetails: setCreateProjectRoleData });
    fetchProjectRoles({ projectName: "SELECT", setProjectRoleDetails: setSelectProjectRoleData });
    fetchCompnayAllowIps();
    setSortValue(sortValue);
    // setSearch(search);
    // setSortOptions(sortOptions);
  }, []);

  useEffect(() => {
    if (allUsers && compantAllowIpData && userInfo && allowIp && initialAllowIpData && initialUserInfo) {
      if (id) {
        setIsDisable(checkEditorNot(userInfo));
      } else {
        setIsDisable(findEmptyValue());
      }
    }
  }, [id, userInfo, allUsers, allowIp, allowFullAccess, selectedDate, compantAllowIpData, initialAllowIpData, initialUserInfo, selectedDate]);

  useEffect(() => {
    setCreateBtn(true);
    if (id) {
      setIsDisable(true);
      setCreateBtnName("Save Changes");
    } else {
      setCreateBtnName("Save User");
    }
    return () => {
      setCreateBtn(false);
      setCreateBtnName("");
      setIsDisable(false);
    };
  }, [id]);

  useEffect(() => {
    setOnSave(() => handleSubmitUserForm);
  }, [userInfo, allowIp, selectedDate]);

  return (
    <>
      <ThemeProvider theme={custumTheme}>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 9999,
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          open={updateUserLoading || createUserLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <Box sx={{ marginTop: "15px", marginLeft: location?.state?.isEditUser ? "-13.5px" : "-10px", marginRight: "0px", marginBottom: "30px" }}>
          <Grid container rowGap="10px" sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
            {usersFilds(roleData, id, createProjectRoleData, selectProjectRoleData).map((item) => (
              <OutlineInput key={item.name} item={item} onChange={handleChnage} value={userInfo[item?.name] || ""} isEditUser={id && item.name === "username" ? true : false} />
            ))}
          </Grid>
          <Box sx={{ padding: "10px", paddingLeft: "25px", paddingRight: "20px" }}>
            <Divider orientation="horizontal" flexItem style={{ borderColor: "#444444", width: "100%", marginBottom: "20px", marginTop: "20px" }} />
          </Box>

          <AllowIpFrom
            allowIp={allowIp}
            setAllowIp={setAllowIp}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            allowFullAccess={allowFullAccess}
            setAllowFullAccess={setAllowFullAccess}
          />

          {/* <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "30px" }}>
            <Button disabled={location?.state?.isEditUser ? checkEditorNot(userInfo) : findEmptyValue()} onClick={handleSubmitUserForm}>
              {location?.state?.isEditUser ? "Save Changes" : "Save User"}
            </Button>
          </Box> */}
        </Box>

        <RemoveModal open={cancelEditUserModal} setOpen={setCancelEditUserModal} btnInfo={modalBtnInfo} heading="Do you want to Discard All Changes?" />
        <ToastContainer />
      </ThemeProvider>
    </>
  );
};
